import {
  DesignCustomisationsInput,
  DesignScene,
} from '@moonpig/web-shared-types-graphql'

const stripTypename = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj.map(stripTypename) as unknown as T
  }

  if (obj && typeof obj === 'object') {
    const newObj: Record<string, unknown> = {}
    Object.keys(obj).forEach(key => {
      if (key !== '__typename') {
        newObj[key] = stripTypename((obj as Record<string, unknown>)[key])
      }
    })
    return newObj as T
  }
  return obj
}

export const mapScenes = (scenes: Partial<DesignScene>[]) => {
  const { customisations } = stripTypename(scenes[0])

  return [
    {
      customisations: customisations as DesignCustomisationsInput,
      index: 0,
    },
  ]
}
